export const CERT_ANNOUNCEMENT_STORAGE_KEY = 'epk-cert-announcement-dismissed';
/** 30.08.2026 — exclusive end (visible through 14.08 inclusive) */
export const CERT_ANNOUNCEMENT_END_DATE = new Date(2026, 7, 31);

export const CERT_ANNOUNCEMENT_LINKS = {
  yandexBrowser: 'https://browser.yandex.ru',
  gosuslugiCert: 'https://www.gosuslugi.ru/crt',
};